import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import themes from "devextreme/ui/themes";
import {values} from "lodash";

@Component({
  selector: 'app-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.scss']
})
export class ThemeToggleComponent implements OnInit {

  public isDarkTheme = window.localStorage.getItem("dx-theme") === "generic.dark.compact";

  constructor() {
  }

  ngOnInit(): void {
    const theme = window.localStorage.getItem("dx-theme") || "generic.light.compact";
    themes.current(theme);
  }

  public toggleChange(e: any) {
    this.isDarkTheme = e.value;
    if (this.isDarkTheme) {
      window.localStorage.setItem("dx-theme", "generic.dark.compact");
    } else {
      window.localStorage.setItem("dx-theme", "generic.light.compact");
    }
    this.changeTheme();
  }

  public changeTheme() {
    let theme = "generic.light.compact";
    if (themes.current() === "generic.light.compact") {
      theme = "generic.dark.compact";
    }

    window.localStorage.setItem("dx-theme", theme);
    themes.current(theme);
  }
}
